import { render } from "./DriverSettings.vue?vue&type=template&id=2fb0f4fe"
import script from "./DriverSettings.vue?vue&type=script&lang=js"
export * from "./DriverSettings.vue?vue&type=script&lang=js"

import "./DriverSettings.vue?vue&type=style&index=0&id=2fb0f4fe&lang=css"
script.render = render

export default script